import * as Yup from 'yup'
import { IBranchModel } from '../branch/BranchModel'

export interface IRentalTermsModel {
  id: string
  branchId: string | null // Artık tüm BranchDAO objesi burada
  branchName?: string
  minimumDays: number
  dayCalculationType: string
  startDate: string
  endDate: string
}

export const initialRentalTerms: IRentalTermsModel = {
  id: '',
  branchId: '',
  branchName: '',
  minimumDays: 0,
  dayCalculationType: '',
  startDate: '',
  endDate: ''
}

export const validationRentalTerms = Yup.object().shape({
  branchId: Yup.string().nullable().required('Şube zorunludur'),
  minimumDays: Yup.number()
    .min(0, 'Minimum gün sayısı negatif olamaz')
    .required('Minimum gün sayısı zorunludur'),
  dayCalculationType: Yup.string().required('Gün hesaplama tipi zorunludur'),
  startDate: Yup.string().required('Başlangıç tarihi zorunludur'),
  endDate: Yup.string()
    .required('Bitiş tarihi zorunludur')
    .test('is-after-start', 'Bitiş tarihi başlangıç tarihinden sonra olmalı', function (value) {
      const { startDate } = this.parent
      return !startDate || !value || new Date(value) >= new Date(startDate)
    })
})

export const DAY_CALC_TYPE = [
  { value: 'Farketmez', label: 'Farketmez' },
  { value: 'Önemli', label: 'Önemli' },
  { value: 'Diğer', label: 'Diğer' },
] as const
